import { useState } from 'react';

import type { App } from '@keboola/api-client/developerPortal/types';
import { Button, Modal } from '@keboola/design';

import { WavePinsForm } from './WavePinsForm';

/** Edits which version each rollout wave is pinned to. */
export function EditWavePinsModal({ app }: { app: App }) {
  const [open, setOpen] = useState(false);

  return (
    <Modal open={open} onOpenChange={setOpen}>
      <Modal.Trigger asChild>
        <Button variant="secondary" size="small">
          Edit pins
        </Button>
      </Modal.Trigger>
      <Modal.Content size="medium">
        <Modal.Header description="A wave without a pin runs the pin of the nearest lower wave, or the latest version. The wave releaser can move these pins at its next hourly run.">
          Rollout wave pins
        </Modal.Header>
        {/* Mounts only while open, so the version list loads only when it is needed. */}
        <WavePinsForm app={app} onSaved={() => setOpen(false)} />
      </Modal.Content>
    </Modal>
  );
}
